






















































import FormInput from "@/components/FormInput.vue";
import FormSelect from "@/components/FormSelect.vue";
import FormInputError from "@/components/FormInputError.vue";
import FormValidation from "@/mixins/form-validation";
import { TRIGGER_TYPE } from "@/config/alert";
import { Alert, DeliveryConfig } from "@/types/alert";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({ components: { FormInput, FormSelect, FormInputError } })
export default class AlertForm extends Mixins(FormValidation) {
  @State(state => state.alerts.deliveryConfigs)
  deliveryConfigs!: DeliveryConfig[];

  @Prop({ required: true })
  alert!: Alert;

  @Prop({ required: true })
  action!: "add" | "update";

  title = "Save";

  isSaving = false;

  triggerTypeError = "";
  thresholdError = "";
  deliveryConfigError = "";

  // Map trigger types to the required FormSelect format
  get triggerTypeOpts() {
    const opts: { [propName: string]: string } = {};
    for (const type in TRIGGER_TYPE) {
      opts[type] = TRIGGER_TYPE[type].label;
    }
    return opts;
  }

  // Map delivery configs to the required FormSelect format
  get deliveryConfigOpts() {
    const opts: { [propName: string]: string } = {};

    for (const deliveryConfig of this.deliveryConfigs) {
      let address = deliveryConfig.email;
      if (deliveryConfig.delivery_type === "slack") {
        address = deliveryConfig.slack_channel;
      }
      if (deliveryConfig.id) {
        opts[deliveryConfig.id] = `${deliveryConfig.delivery_type}: ${address}`;
      }
    }
    return opts;
  }

  saveAlert() {
    this.triggerTypeError = this.validateString(this.alert.trigger_type, "Please choose a trigger type");
    if (this.triggerTypeError) return;

    this.thresholdError = this.validateTriggerThreshold(this.alert.trigger_threshold);
    if (this.thresholdError) return;

    this.deliveryConfigError = this.validateNumber(
      this.alert.delivery_config_id,
      "Please choose a delivery destination",
    );
    if (this.deliveryConfigError) return;

    this.$ga.button(`${this.action} alert`);

    this.title = "Saving";
    this.isSaving = true;

    this.$store.dispatch(`alerts/${this.action}`, this.alert).then(() => {
      this.title = "Saved!";
      this.isSaving = false;
      setTimeout(() => {
        this.title = "Save";
        this.$emit("closeAfterSave");
      }, 1000);
    });
  }

  validateTriggerThreshold(threshold: number | null): string {
    if (threshold && threshold >= 1 && threshold <= 99) {
      return "";
    }
    return "Choose a threshold must be between 1-99";
  }
}
